import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useAdminAuth } from "@/lib/auth";
import { TID } from "@/lib/testIds";
import {
  LayoutDashboard, Package, ShoppingCart, FileText, Users,
  Settings, Database, LogOut, ExternalLink,
} from "lucide-react";

const LINKS = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/products", label: "Products", icon: Package },
  { to: "/admin/orders", label: "Orders", icon: ShoppingCart },
  { to: "/admin/pages", label: "Pages", icon: FileText },
  { to: "/admin/signups", label: "Email Signups", icon: Users },
  { to: "/admin/sourcing", label: "Sourcing", icon: Database },
  { to: "/admin/settings", label: "Settings", icon: Settings },
];

export default function AdminLayout() {
  const { user, logout } = useAdminAuth();
  const nav = useNavigate();
  return (
    <div className="bls-admin flex">
      {/* Sidebar */}
      <aside className="w-64 bg-[#16161f] border-r border-[#2a2a3d] flex flex-col min-h-screen sticky top-0">
        <div className="px-6 py-6 border-b border-[#2a2a3d]">
          <div className="flex items-center gap-1">
            <span className="font-display text-xl font-bold text-white">bles</span>
            <span className="font-display text-xl font-bold text-[#7f77dd]">co</span>
            <span className="ml-2 text-[10px] uppercase tracking-widest text-white/35 font-semibold">Admin</span>
          </div>
        </div>
        <nav className="flex-1 px-3 py-4 space-y-1">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={`${TID.adminSidebarLink}-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) => `bls-side-link ${isActive ? "bls-side-link-active" : ""}`}
            >
              <l.icon className="w-4 h-4" /> {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="px-3 py-3 border-t border-[#2a2a3d] space-y-1">
          <a href="/" target="_blank" rel="noreferrer" className="bls-side-link">
            <ExternalLink className="w-4 h-4" /> View store
          </a>
          <button
            onClick={() => { logout(); nav("/admin/login"); }}
            className="bls-side-link w-full text-left"
            data-testid={TID.adminLogout}
          >
            <LogOut className="w-4 h-4" /> Sign out
          </button>
          {user && (
            <div className="px-4 pt-3 text-xs text-white/40 truncate">{user.email}</div>
          )}
        </div>
      </aside>

      {/* Content */}
      <main className="flex-1 min-h-screen p-8 max-w-[calc(100vw-16rem)]">
        <Outlet />
      </main>
    </div>
  );
}
